import { render } from "./Retail.vue?vue&type=template&id=32cbbe4c&scoped=true"
import script from "./Retail.vue?vue&type=script&lang=js"
export * from "./Retail.vue?vue&type=script&lang=js"

import "../style/buildingDevelopment.scss?vue&type=style&index=0&id=32cbbe4c&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=32cbbe4c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cbbe4c"]])

export default __exports__